import { Vector2, Vector3 } from "three";

export const addEase = (pos: number, to: number, easing: number): number => {
  return pos + (to - pos) / easing;
};

export const addEase2 = (pos: Vector2, to: Vector2, easing: number): void => {
  pos.x += (to.x - pos.x) / easing;
  pos.y += (to.y - pos.y) / easing;
};

export const addEase3 = (pos: Vector3, to: Vector3, easing: number): void => {
  pos.x += (to.x - pos.x) / easing;
  pos.y += (to.y - pos.y) / easing;
  pos.z += (to.z - pos.z) / easing;
};
